import { createTRPCProxyClient, httpBatchLink } from "@trpc/client"
import type { AppRouter } from "@/lib/trpc/app-router"
import { enqueueRequest } from "@/lib/request-queue"
import { CLIENT_ID } from "@/lib/client-id"

// In the browser a relative URL hits the same origin. The guide route runs a
// data-only SSR pass (so crawlers get the real banner og:image in raw HTML) —
// there the loader's tRPC call executes in Node, where fetch() needs an
// absolute URL. Point it at our own origin (BETTER_AUTH_URL in dev/prod).
const TRPC_URL =
  typeof document !== `undefined`
    ? `/api/trpc`
    : `${process.env.BETTER_AUTH_URL ?? `https://chictravel.ai`}/api/trpc`

export const trpc = createTRPCProxyClient<AppRouter>({
  links: [
    httpBatchLink({
      url: TRPC_URL,
      async headers() {
        return {
          cookie: typeof document !== `undefined` ? document.cookie : ``,
          "x-client-id": CLIENT_ID,
        }
      },
      async fetch(url, options) {
        return enqueueRequest(() => fetch(url, options))
      },
    }),
  ],
})
